import { IDataStorage } from '../internal/data-storage';
import { InternalIndex } from '../internal/internal-index';
import { InternalTable } from '../internal/internal-table';

export class ChecklistQuestionStorage implements IDataStorage {
    Index: InternalIndex = new InternalIndex('internalId', 'internalId', true, false);
    IdIndex: InternalIndex = new InternalIndex('id', 'id', false, false);
    tableDefinition: InternalTable = new InternalTable('ChecklistQuestions', 'internalId', true, [this.Index, this.IdIndex]);
    
    internalId: number;
    id: string;
    questionText: string;

    static getTableDefinition(): InternalTable {
        return new ChecklistQuestionStorage().tableDefinition;
    }
}
